import script from "./query-toolbar-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./query-toolbar-header.vue?vue&type=script&setup=true&lang=ts"

import "./query-toolbar-header.vue?vue&type=style&index=0&id=fc4c0650&lang=scss"

const __exports__ = script;

export default __exports__